export default __webpack_public_path__ + "static/media/CIR_S_XLG.119f1a11.png";